import {
  ADD_COMMENTS,
  ADD_COMMENTS_PLACEHOLDER,
  ACCEPT,
  CHANGE_LANGUAGE_PROMPT_DESCRIPTION,
  CHANGE_LANGUAGE_PROMPT_TITLE,
  CONFIRMED,
  CONFIRMED_DESCRIPTION,
  EDIT_ORDER,
  FETCHING_ORDER,
  MAKE_ORDER,
  MY_ORDER,
  ORDER,
  PENDING,
  PENDING_DESCRIPTION,
  REJECTED,
  REJECTED_DESCRIPTION,
  REMOVE_ITEM_FROM_ORDER,
  REMOVE_ORDER_PROMPT_DESCRIPTION,
  REMOVE_ORDER_PROMPT_TITLE,
  ROOM,
  SEARCH,
  SELECT,
  SELECT_ROOM,
  SENDING_ORDER,
  SELECT_TABLE,
  SELECT_GETTING_THE_ORDER,
  SELECT_THE,
  SELECT_SEND_TO,
  SEND_TO,
  TABLE,
  TOTAL,
  VIEW_ORDER,
  WRITE_ADDRESS,
  WRITE_ADDRESS_SEND_TO,
  STREET,
  NUMBER,
  APARTMENT_NUMBER,
  STREET_CORNER,
  PHONE_NUMBER,
  PHONE_NUMBER_DESCRIPTION,
  SHIPPING,
  PAYMENT_METHOD,
  CASH,
  MANDATORY,
} from './keys';

const translation = {
  // View Menu
  [ADD_COMMENTS]: 'Adicione comentários',
  [ADD_COMMENTS_PLACEHOLDER]: 'Escreva até 100 caracteres',
  [ACCEPT]: 'Aceitar',
  [CHANGE_LANGUAGE_PROMPT_TITLE]: 'Seleção de idioma',
  [CHANGE_LANGUAGE_PROMPT_DESCRIPTION]: 'Selecione o novo idioma dos textos:',
  [CONFIRMED]: 'Confirmado',
  [CONFIRMED_DESCRIPTION]: 'Seu pedido foi confirmado pelo local e será entregue em minutos.',
  [EDIT_ORDER]: 'Editar pedido',
  [FETCHING_ORDER]: 'Obtendo pedido...',
  [MAKE_ORDER]: 'Realizar pedido',
  [MY_ORDER]: 'Meu pedido',
  [ORDER]: 'Pedido',
  [PENDING]: 'Pendente',
  [PENDING_DESCRIPTION]: 'Seu pedido está aguardando confirmação pelo local.',
  [REJECTED]: 'Rejeitado',
  [REJECTED_DESCRIPTION]: 'Seu pedido foi rejeitado pelo local.',
  [REMOVE_ITEM_FROM_ORDER]: 'Remover do pedido',
  [REMOVE_ORDER_PROMPT_TITLE]: 'Deleatar pedido',
  [REMOVE_ORDER_PROMPT_DESCRIPTION]: 'Deseja deletar seu pedido?',
  [ROOM]: 'Quarto',
  [SEARCH]: 'Procurar',
  [SELECT]: 'Selecione',
  [SELECT_SEND_TO]: 'Selecione o destino',
  [SELECT_THE]: 'Selecione',
  [SELECT_GETTING_THE_ORDER]: 'para receber o pedido.',
  [SELECT_ROOM]: 'Selecione quarto',
  [SELECT_TABLE]: 'Selecione a mesa',
  [SEND_TO]: 'Enviar para',
  [TABLE]: 'Mesa',
  [TOTAL]: 'Total',
  [SENDING_ORDER]: 'Enviando pedido...',
  [VIEW_ORDER]: 'Veja o pedido',
  [WRITE_ADDRESS]: 'Escrever informações de entrega',
  [WRITE_ADDRESS_SEND_TO]: 'Informações de entrega',
  [STREET]: 'Rua',
  [NUMBER]: 'Número da porta',
  [APARTMENT_NUMBER]: 'Departamento',
  [STREET_CORNER]: 'Esquina',
  [PHONE_NUMBER]: 'Número de telefone',
  [PHONE_NUMBER_DESCRIPTION]: 'Usaremos para notificá-lo sobre o status da entrega',
  [SHIPPING]: 'Frete',
  [PAYMENT_METHOD]: 'Método de pagamento',
  [CASH]: 'Dinheiro / POS',
  [MANDATORY]: 'Obrigatório',
};

export default translation;
